<template>
    <div :class="cn('flex gap-4 items-center px-6 pb-4 -mx-6 border-b border-gray-100', props.class)">
        <slot />
    </div>
</template>
<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const props = defineProps<{
    class?: HTMLAttributes["class"];
}>();
</script>
